// tslint:disable-next-line:no-var-requires
const _ = require('lodash');
const moment = require('moment');

import {
  BuildingData,
  LineInitialCampaignCostData,
  LineInitialCostData,
} from '@/@types/json/hikari';

export class Course {
  public entryTypeId: string;
  public entryTypeName: string;
  public buildingId: string;
  public currentUsageType: string;
  public applyTypeId: string;
  readonly initChargeDetails: InitialChargeDetail[];
  readonly regularMonthlyCharge: number;
  readonly campaignMonthlyCharge: number;

  constructor(entryTypeId: string, entryTypeName: string, data: BuildingData) {
    this.entryTypeId = entryTypeId; // flets other new
    this.entryTypeName = entryTypeName; // 日本語 回線新規 事業者変更 フレッツ光からの乗換
    this.buildingId = data.id; // family mansion
    this.currentUsageType = data.現在ご利用中のタイプ; // 1g 10g
    this.applyTypeId = data.申込タイプ; // 申込タイプ 1g 10g
    this.initChargeDetails = _.map(data.初期費用, (c: LineInitialCostData) => {
      return new InitialChargeDetail(c.id, c.名前, c.標準料金, c.特典);
    });
    this.regularMonthlyCharge = data.月額費用.標準料金;
    this.campaignMonthlyCharge = data.月額費用.特典料金;
  }

  public initialCharge(): number {
    return this.initChargeDetails.reduce(
      (z: number, detail: InitialChargeDetail) => {
        return (z += detail.Charge());
      },
      0
    );
  }

  public monthlyCharge(): number {
    return this.campaignMonthlyCharge || this.regularMonthlyCharge;
  }
}

class InitialChargeDetail {
  public id: string;
  public name: string;
  readonly regularCharge: number;
  readonly campaignCharge: number | null;
  readonly campaignStartAt: any; // moment()
  readonly campaignEndAt: any; // moment()

  constructor(
    id: string,
    name: string,
    regularCharge: number,
    campaignInfo: LineInitialCampaignCostData
  ) {
    this.id = id;
    this.name = name;
    this.regularCharge = regularCharge;
    if ('料金' in campaignInfo) {
      this.campaignCharge =
        campaignInfo.料金 !== undefined ? campaignInfo.料金 : null;
      this.campaignStartAt =
        campaignInfo.開始 !== undefined ? moment(campaignInfo.開始) : null;
      this.campaignEndAt =
        campaignInfo.終了 !== undefined ? moment(campaignInfo.終了) : null;
    } else {
      this.campaignCharge = null;
      this.campaignStartAt = null;
      this.campaignEndAt = null;
    }
  }

  public Charge(): number {
    return this.campaignCharge != null && this.inCampaign()
      ? this.campaignCharge
      : this.regularCharge;
  }

  public inCampaign(): boolean {
    const now = moment();
    // isBetween評価範囲(第4引数：同じ値を含めるか) '[]'：(start_at <= now < end_at)
    return now.isBetween(this.campaignStartAt, this.campaignEndAt, null, '[)');
  }
}
